export default __webpack_public_path__ + "static/media/img_other16.9a03b8f6.webp";